import React, { useState, useContext, useEffect } from "react";
import "./payForItems.scss";
import { useHistory } from "react-router-dom";

// material ui
import PropTypes from "prop-types";
import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Backdrop from "@mui/material/Backdrop";
import { grey } from "@mui/material/colors";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Checkbox from "@material-ui/core/Checkbox";
import CircleChecked from "@material-ui/icons/CheckCircleOutline";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { useSelector, useDispatch } from "react-redux";
import { FormControlLabel } from "@material-ui/core";
import CheckIcon from "../../Assets/images/CheckIcon.svg"
import { get_lang } from "../../Functions/getLang";
import { CollectionsBookmarkOutlined } from "@mui/icons-material";
import LoaderAnimation from "../LoaderAnimation";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

function PayForItems(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    paidAmount,
    subTotal,
    orders,
    paySelectedItems,
    setPaySelectedItems,
    setPartialType,
    splitBillAmount,
    setSplitBillAmount,
    partialInvoice,
    store
  } = props;
  const [orderId, setOrderId] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const [checked, setChecked] = React.useState(false);

  const handleConfirm = () => {
    let remain = parseFloat((subTotal - paidAmount).toFixed(3))
    if (splitBillAmount > remain) {

      appDispatch({
        type: "SHOW_ALERT",
        alertType: "error",
        message: `Product amount is greater than remaining Bill`,
      });
    } else {
      appDispatch({
        type: "setPayForItems",
        payForItems: false,
      });
      appDispatch({
        type: "setSplitBillOptions",
        splitBillOptions: false,
      });
      appDispatch({
        type: "setSplitBill",
        splitBill: true,
      });
      localStorage.removeItem("payForItems")
      localStorage.removeItem("splitBillOptions")
      localStorage.setItem("splitBill", Boolean(true))
      localStorage.setItem('selectedItems', JSON.stringify(paySelectedItems))

      setPartialType('product')
    }

  }

  const handleSelectOrder = (event, index) => {
    let itemAmount = event.target.value;
    let id = event.target.id;
    let selectedItem = [...paySelectedItems];

    let findProd = paySelectedItems.find((x) => x.order_id == id)
    if (findProd) {
      selectedItem.splice(paySelectedItems.indexOf(findProd), 1)
    } else {
      let sumAddons = 0
      let orderId = 0
      orders.forEach(ele => {
        if (ele.meta == id) {
          sumAddons = ele.sum_addons;
        }
      });
      let data = {
        addons_total: sumAddons,
        order_id: id,
        amount: parseFloat(itemAmount).toFixed(3),
      };
      selectedItem.push(data);
    }
    setPaySelectedItems(selectedItem);

    let findOrderID = orderId.find((x) => x == event.target.id)
    // console.log(findOrderID)
    if (findOrderID) {
      orderId.splice(orderId.indexOf(findOrderID), 1);
    } else {
      orderId.push(event.target.id);
    }
    setOrderId(orderId);
    // console.log(orderId)


  };
  useEffect(() => {
    if (paySelectedItems.length > 0) {
      let totalAmount = 0
      paySelectedItems.forEach(element => {
        totalAmount += parseFloat(element.amount) + parseFloat(element.addons_total);
        setSplitBillAmount(totalAmount)
      });
    } else {
      setSplitBillAmount(0)
    }

  }, [paySelectedItems])

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem("selectedItems"))

    if (localData && localData.length > 0) {
      setPaySelectedItems(localData);
      localData.forEach((ele, i) => {
        orderId.push(ele.order_id)
      });
      setOrderId(orderId)
    }
  }, [])


  const handleChangeSplit = () => {
    appDispatch({
      type: "setPayForItems",
      payForItems: false,
    });
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: true,
    });
    localStorage.removeItem("payForItems");
    localStorage.setItem("splitBillOptions", true);
    localStorage.removeItem("selectedItems")
    setSplitBillAmount(0)
    setPaySelectedItems([])
  };
  var meta = [];
  const handleMeta = () => {
    partialInvoice.filter((x) => x.status === 'Paid').forEach(x => x.meta.partial_type === "product" && meta.push(x.meta.data));
    // partialInvoice.filter((x) => x.status === 'Paid').forEach(x=>x.meta.forEach(x=> x.partial_type === "product" && meta.push(x)));
    setIsLoading(false)
  }

  useEffect(() => {
    if (partialInvoice.length > 0) {
      setIsLoading(true)
      handleMeta()
    }
  }, [partialInvoice])


  return (
    <>
      <div
        id="mySidenav"
        className={`PayForItems  ${appState.langValue == "ar" ? "PayForItemsArabic" : " "
          }`}
      >

        {isLoading ?

          <div >
            <LoaderAnimation />
          </div>
          :
          <div className="container-fluid content px-4 pb-3 mt-3">
            <h1
              className={` ${appState.langValue === "ar"
                  ? "text-right familyGraphikArabic800 "
                  : " familyPoppins600"
                }`}
            >
              {t("invoice.Pay-for-your-items")}
            </h1>
            <div className="row classForCheckBoxBtn mt-3 px-2">



              {orders.length > 0
                ? orders.map((order, ind) => {

                  // console.log("orders", orders)

                  return (
                    !meta.some((x) => x.order_id == order.meta) && (
                      order.status != "Rejected" &&
                      <div
                        className="col-12 m-0 p-0"
                        onChange={(e) => handleSelectOrder(e, ind)}
                      >
                        <Checkbox
                          id={order.meta}
                          value={order.total.toFixed(3)}
                          {...label}
                          checked={orderId.includes(order.meta) ? true : false}
                          icon={
                            <Button
                              className={`py-3 px-3 my-2 d-flex justify-content-between ${appState.langValue === "ar"
                                  ? " familyGraphikArabic600 "
                                  : ""
                                }`}
                            >
                              <span
                                className={` d-flex justify-content-between ${appState.langValue === "ar"
                                    ? " familyGraphikArabic600 "
                                    : ""
                                  }`}
                              >
                                {/* {order.product.name.en} */}
                                {get_lang(
                                  order.product.name,
                                  appState.langValue
                                )}
                              </span>{" "}

                              <div className="d-flex">
                                {order.discount>0 &&  <span className="m-0 px-1 text-danger">
                                {appState.langValue === "en"&&<span>-</span>}{order.discount.toFixed(3)} {appState.langValue === "ar"&&<span>-</span>} {t(`${store?.currency}`)} 
                                </span>}
                             
                                <div className="d-flex">
                                  <span className="px-2">
                                    {order.total.toFixed(3)} {t(`${store?.currency}`)}
                                  </span>{" "}
                                  <span>
                                    {appState.langValue === "ar" ? (
                                      <svg
                                        width="19"
                                        height="18"
                                        viewBox="0 0 19 18"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill="#DCDCDC"
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M9 18C13.9706 18 18 13.9706 18 9C18 7.2993 17.5283 5.70877 16.7085 4.35213L18.5303 2.53033C18.8232 2.23744 18.8232 1.76256 18.5303 1.46967C18.2374 1.17678 17.7626 1.17678 17.4697 1.46967L15.8164 3.12296C14.166 1.21049 11.7244 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM15.8164 3.12296L9 9.93934L6.53033 7.46967C6.23744 7.17678 5.76256 7.17678 5.46967 7.46967C5.17678 7.76256 5.17678 8.23744 5.46967 8.53033L8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75C9.19891 11.75 9.38968 11.671 9.53033 11.5303L16.7085 4.35213C16.4456 3.91698 16.1468 3.5059 15.8164 3.12296Z"
                                        />
                                      </svg>
                                    ) : (
                                      <svg
                                        width="19"
                                        height="18"
                                        viewBox="0 0 19 18"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill="#DCDCDC"
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M9 18C13.9706 18 18 13.9706 18 9C18 7.2993 17.5283 5.70877 16.7085 4.35213L18.5303 2.53033C18.8232 2.23744 18.8232 1.76256 18.5303 1.46967C18.2374 1.17678 17.7626 1.17678 17.4697 1.46967L15.8164 3.12296C14.166 1.21049 11.7244 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM15.8164 3.12296L9 9.93934L6.53033 7.46967C6.23744 7.17678 5.76256 7.17678 5.46967 7.46967C5.17678 7.76256 5.17678 8.23744 5.46967 8.53033L8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75C9.19891 11.75 9.38968 11.671 9.53033 11.5303L16.7085 4.35213C16.4456 3.91698 16.1468 3.5059 15.8164 3.12296Z"
                                        />
                                      </svg>
                                    )}
                                  </span>
                                </div>{" "}
                               
                              </div>

                            </Button>
                          }
                          checkedIcon={
                            <Button
                              className={`py-3 px-3 my-2 d-flex justify-content-between ${appState.langValue === "ar"
                                  ? " familyGraphikArabic600 "
                                  : ""
                                }`}
                            >
                              <span>
                                {" "}
                                {get_lang(
                                  order.product.name,
                                  appState.langValue
                                )}
                              </span>{" "}
                              <div className="d-flex ">
                              {order.discount>0 &&  <span className="m-0 px-1 text-danger">
                              {appState.langValue === "en"&&<span>-</span>}{order.discount.toFixed(3)} {appState.langValue === "ar"&&<span>-</span>} {t(`${store?.currency}`)}
                                </span>}
                              <div className="d-flex">
                                {order.addons.length > 0 && (
                                  <span className="text-muted">
                                    <span className="px-1">
                                      {" "}
                                      {order.sum_addons.toFixed(3)}
                                    </span>
                                    <span className="px-1">{t(`${store?.currency}`)}</span>{" "}
                                  </span>
                                )}
                                <span className="px-2">
                                  {order.total.toFixed(3)} {t(`${store?.currency}`)}
                                </span>{" "}
                                <span>
                                  {appState.langValue === "ar" ? (
                                    <svg
                                      width="19"
                                      height="18"
                                      viewBox="0 0 19 18"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill="#60B200"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M9 18C13.9706 18 18 13.9706 18 9C18 7.2993 17.5283 5.70877 16.7085 4.35213L18.5303 2.53033C18.8232 2.23744 18.8232 1.76256 18.5303 1.46967C18.2374 1.17678 17.7626 1.17678 17.4697 1.46967L15.8164 3.12296C14.166 1.21049 11.7244 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM15.8164 3.12296L9 9.93934L6.53033 7.46967C6.23744 7.17678 5.76256 7.17678 5.46967 7.46967C5.17678 7.76256 5.17678 8.23744 5.46967 8.53033L8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75C9.19891 11.75 9.38968 11.671 9.53033 11.5303L16.7085 4.35213C16.4456 3.91698 16.1468 3.5059 15.8164 3.12296Z"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      width="19"
                                      height="18"
                                      viewBox="0 0 19 18"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill="#60B200"
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M9 18C13.9706 18 18 13.9706 18 9C18 7.2993 17.5283 5.70877 16.7085 4.35213L18.5303 2.53033C18.8232 2.23744 18.8232 1.76256 18.5303 1.46967C18.2374 1.17678 17.7626 1.17678 17.4697 1.46967L15.8164 3.12296C14.166 1.21049 11.7244 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM15.8164 3.12296L9 9.93934L6.53033 7.46967C6.23744 7.17678 5.76256 7.17678 5.46967 7.46967C5.17678 7.76256 5.17678 8.23744 5.46967 8.53033L8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75C9.19891 11.75 9.38968 11.671 9.53033 11.5303L16.7085 4.35213C16.4456 3.91698 16.1468 3.5059 15.8164 3.12296Z"
                                      />
                                    </svg>
                                  )}
                                </span>
                              </div>{" "}
                          
                              </div>
                          
                            </Button>
                          }
                        />
                      </div>
                    )
                  );

                })
                : ""}
            </div>
            <div className="d-flex  align-items-center py-3 w-100 justify-content-between ">
              <h5
                className={` totalAmount mb-0  ${appState.langValue === "ar" ? "text-right" : "familyManrope800"
                  }`}
              >
                {t("invoice.Total-Bill")}:
              </h5>
              <h5
                className={` totalAmount mb-0 ${appState.langValue === "ar" ? "text-right" : "familyManrope800"
                  }`}
              >
                <span className="px-1"> {splitBillAmount.toFixed(3)}</span>
                <span className="px-1">{t(`${store?.currency}`)}</span>{" "}
              </h5>
            </div>

            <div className="bottomBtn">
              <Button
                onClick={handleConfirm}
                disabled={splitBillAmount <= 0}
                className={` py-3 px-4  mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                  } ${splitBillAmount <= 0 ? `disabledBtn` : `confirmBtn`}`}
              >
                {" "}
                <span className="text-capitalize">
                  {t("invoice.Confirm")}
                </span>{" "}
              </Button>
              <Button
                onClick={handleChangeSplit}
                className={` py-3 px-4 mt-3 deletebtn justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                  }`}
              >
                {" "}
                <span className="text-capitalize">
                  {t("invoice.Delete-Split")}
                </span>{" "}
              </Button>
            </div>
          </div>
        }

        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}

      </div>
    </>
  );
}

export default withTranslation()(PayForItems);
